import en from "./en";
import hi from "./hi";
import pa from "./pa";

const dicts = { en, hi, pa };
let lang = localStorage.getItem("ttw_lang") || "en";
const listeners = new Set();

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "हिं", name: "हिन्दी" },
  { code: "pa", label: "ਪੰ", name: "ਪੰਜਾਬੀ" },
];

export const getLang = () => lang;

export const setLang = (l) => {
  if (!dicts[l]) return;
  lang = l;
  localStorage.setItem("ttw_lang", l);
  document.documentElement.lang = l;
  listeners.forEach((f) => f(l));
};

export const onLangChange = (f) => {
  listeners.add(f);
  return () => listeners.delete(f);
};

const lookup = (dict, key) =>
  key.split(".").reduce((o, k) => (o != null && o[k] !== undefined ? o[k] : undefined), dict);

export const t = (key, fallback) => {
  const v = lookup(dicts[lang], key);
  if (v !== undefined) return v;
  const e = lookup(en, key);
  return e !== undefined ? e : fallback !== undefined ? fallback : key;
};
